<style lang="scss" scoped>
.izt-container-container {
  .title-container {
    padding-bottom: 16px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left, .right {
      display: flex;
      align-items: center;
      .left-text {
        font-weight: 500;
        font-size: 28px;
        color: var(--izt-background-text-color-65);
        text-align: left;
        font-style: normal;
        margin-left: 4px;
      }
      .right-text {
        font-weight: 400;
        font-size: 26px;
        color: var(--izt-background-text-color-65);
        text-align: right;
        text-transform: none;
      }
      [class*="icon-"] {
        font-size: 28px!important;
        color: var(--izt-theme-color);
      }
    }
    .right {
      cursor: pointer;
      &:active {
        opacity: 0.8;
      }
    }
  }
  .main-container {
    font-size: 28px;
  }
}
</style>

<template>
  <div :class="['izt-container-container']">
    <div class="title-container" v-if="label">
      <div class="left">
        <izt-icon class-name="icon-a-171show_biaotitishi"></izt-icon>
        <span class="left-text">{{label}}</span>
      </div>
      <div class="right" v-if="rightText" @click.stop="emit('right-click')">
        <span class="right-text">{{rightText}}</span>
        <izt-icon class-name="icon-youjiantou"></izt-icon>
      </div>
    </div>
    <div :class="['main-container', className]">
      <slot></slot>
    </div>
  </div>
</template>

<script setup name="izt-container">
  defineOptions({ name: 'izt-container' })
  defineProps({
    className: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    rightText: { // 右侧文字 左侧文字不设置不显示
      type: String,
      default: ''
    }
  });
  const emit = defineEmits(['right-click']);
</script>